import { instanceApi } from './api'

export const getVendasPorAssinatura = async( idAssinatura ) => {
  const response = await instanceApi.get( `v1/assinatura/${idAssinatura}/vendas` )
  return response.data
}
